import { z } from 'zod';

export const zodDeleteCallOffItemEndpointSchema = z.tuple([
  z.literal('calloffs'),
  z.uuid(),
  z.literal('items'),
  z.uuid(),
]);
